// Hubble's environment seam. Detection and the shared API/Dashboard URLs live
// in @freightsimple/app-shell so the carrier portal shares one definition; this
// re-exports them and adds the one helper that is Hubble's alone.
//
// Not a compatibility shim to be unpicked — it earns its keep. Ten test files
// mock `@/environment` as a single module; pointed at the package subpath
// instead they would each have to mock a dependency they don't own. Keep new
// environment reads coming through here.
// Import the narrow environment subpath, not the package barrel: the barrel
// also pulls in the api/toast layer (and ui-core), which would make the
// environment.test.tsx resetModules + re-import graph huge enough to time out.
import {
  environment,
  isProduction,
  isLocal,
  isLocalOverride,
  apiServerUrl,
  dashboardBaseUrl,
} from "@freightsimple/app-shell/environment";

// Only what Hubble actually reads. `isDemo` and the `AppEnvironment` type are
// there in the package for whoever needs them; re-exporting them here just to
// have them was how they ended up looking used.
export {
  environment,
  isProduction,
  isLocal,
  isLocalOverride,
  apiServerUrl,
  dashboardBaseUrl,
};

export function isAuthenticationDisabled(): boolean {
  return isLocal() && import.meta.env["VITE_DISABLE_AUTHENTICATION"] === "true";
}
